import { FormValidationFunction } from "@/views/interfaces/vuetify/form.interface";


export default class EditComponentForm {
  public name: string = '';
  public status: string = '';

  public rules: { [key: string]: FormValidationFunction[] } = {
    nameRules: [
      (v: string) => !!v || 'Component must have a name',
      (v: string) => v.length >= 3 || 'Component name must be at least 3 characters',
    ],
    statusRules: [
      (v: string) => !!v || 'Component must have a status',
    ],
  };
}
